export type ToolbarState = 'elAnimation' | 'elStyle' | 'elPosition' | 'slideStyle' | 'slideAnimation' | 'multiPosition'

export const ToolbarStates = {
  EL_ANIMATION: 'elAnimation',
  EL_STYLE: 'elStyle',
  EL_POSITION: 'elPosition',
  SLIDE_STYLE: 'slideStyle',
  SLIDE_ANIMATION: 'slideAnimation',
  MULTI_POSITION: 'multiPosition',
}